<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import Select from '$components/Form/Select.svelte';
    import MeltMultiSelect from '$components/Form/MeltMultiSelect.svelte';
    import find from 'lodash/find';
    import Textarea from '$components/Form/Textarea.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const countryOptions = [
        'Allemagne',
        'Angleterre',
        'Belgique',
        'France',
        'Canada',
        'Maroc',
        `Autre`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const currentEducationLevelOptions = [
        'Terminale (ou équivalent)',
        'Bac +1 à Bac +2',
        'Bac +3 ou plus',
        'En reprise d’études',
        'Autre',
    ].map((v) => ({ label: v, value: v, key: v }));

    const serviceOptions = [
        'Préinscription / Inscription en école ou université',
        'Aide pour le visa étudiant',
        'Recherche de logement',
        'Aide administrative (transport, inscription, permis d’étude…)',
        'Conseil en orientation',
        'Autre',
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.visaEtude.country}
        class=""
        let:field
        let:id
        label={`Dans quel pays souhaitez-vous étudier ?`}
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={countryOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.visaEtude.currentEducationLevel}
        class=""
        let:field
        let:id
        label={`Quel est votre niveau d’études actuel ?`}
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={currentEducationLevelOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.visaEtude.services}
        class=""
        let:field
        let:id
        label={`Quels services vous intéressent ?`}
        helpLabel="Plusieurs choix possibles"
    >
        <MeltMultiSelect
            {form}
            {field}
            {id}
            options={serviceOptions}
            valueToOption={(v) => ({
                value: v,
                label: find(serviceOptions, (o) => o.value === v)?.label ?? '',
            })}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin, soyez le plus précis dans votre demande de devis"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin, soyez le plus précis dans votre demande de devis`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
